import { userInfoReducer } from './user';
import { PAARegistrationReducer } from './PAARegistration';
import { standardUserReducer } from './SURegistration';
import { verifyClaimReducer } from './verifyClaim';
import { onLoadingReducer } from './landing/index';
import { TINReducer } from './taxInformation';
import { onStepperReducer } from './stepper';
import { editingReducer } from './editing';
import { reloadPopupReducer } from './reloadPopup';
import { dentalReducer } from './dental';
import { medicaidInfoReducer } from './medicaid';

export const reducers = {
  user: userInfoReducer,
  landing: onLoadingReducer,
  TINDetails: TINReducer,
  primaryAdmin: PAARegistrationReducer,
  standardUser: standardUserReducer,
  verifyClaim: verifyClaimReducer,
  stepper: onStepperReducer,
  editing: editingReducer,
  reloadPopup: reloadPopupReducer,
  dental: dentalReducer,
  medicaid: medicaidInfoReducer,
};
